function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M15 3.75H3a.75.75 0 00-.75.75v9c0 .414.336.75.75.75h12a.75.75 0 00.75-.75v-9a.75.75 0 00-.75-.75z",
  stroke: "var(--text-color-1)",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M15 4.125L9 9.75 3 4.125",
  stroke: "var(--text-color-1)",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

function SvgEmail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2);
}

export default SvgEmail;